"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";
import { useMergeCart } from "@/features/cart/api/hooks/use-merge-cart";
import { useCartStore } from "@/features/cart/components";
import { resolveCartMergeAction } from "@/features/cart/utils/resolve-cart-merge-action";
import { useGetUser } from "@/features/panel/hooks/use-get-user";

export const useCartMerge = () => {
  const { isLoaded, isSignedIn } = useUser();
  const sourceCartId = useCartStore((state) => state.cartId);
  const hasSourceItems = useCartStore((state) => state.items.length > 0);
  const setCartId = useCartStore((state) => state.setCartId);

  const { data: user, isSuccess } = useGetUser({
    enabled: isLoaded && isSignedIn,
  });
  const targetCartId = user?.lastCartId ?? null;

  const { mutate: mergeCart } = useMergeCart();

  const handledRef = useRef(false);

  useEffect(() => {
    if (!(isLoaded && isSignedIn && isSuccess)) {
      return;
    }

    if (handledRef.current) {
      return;
    }

    const action = resolveCartMergeAction({
      sourceCartId,
      hasSourceItems,
      targetCartId,
    });

    if (action.type === "none") {
      return;
    }

    handledRef.current = true;

    if (action.type === "adopt") {
      setCartId(action.targetCartId);
      return;
    }

    mergeCart({
      sourceCartId: action.sourceCartId,
      targetCartId: action.targetCartId,
    });
  }, [
    isLoaded,
    isSignedIn,
    isSuccess,
    sourceCartId,
    hasSourceItems,
    targetCartId,
    setCartId,
    mergeCart,
  ]);
};
